import React, { PureComponent } from 'react';
import {
  Alert,
  Nav,
  NavItem,
  Button,
  Breadcrumb,
  BreadcrumbItem,
  Col,
  Container,
  ListGroup,
  ListGroupItem,
  Row
} from 'reactstrap';
import numeral from 'numeral';
import MaterialIcon from 'material-icons-react';
import { connect } from 'react-redux';
import { compact } from 'underscore';
import moment from 'moment';
import { LinkContainer } from 'react-router-bootstrap';
import { Link } from 'react-router-dom';
import Lightbox from 'react-images';
import URI from 'urijs';
import cx from 'classnames';

// modules
import BS from '../../theme/Bootstrap';
import styles from '../Containers.module.scss';
import cmpStyle from '../../components/Components.module.scss';

// ducks
import { fetch, PROPERTY_TYPE_MAP } from '../../ducks/PropertySearch';
import { CONTACT_SUBMIT } from '../../ducks/Home';
import { ADD_FAVORITE, REMOVE_FAVORITE, isFavorite } from '../../ducks/FavoriteSearch';

// components
import LoadError from '../../components/load-error/load-error';
import AgentCard from '../../partials/agent-card/agent-card';
import ResponsiveCarousel from '../../components/carousel/carousel';

// containers
import PropertyDetailContactAgentForm from './PropertyDetailContactAgentForm';
import PropertyDetailMap from './PropertyDetailMap';
import FavoriteSearchEmailModal from '../FavoriteSearch/FavoriteSearchEmailModal';

// images
import notfound from '../PropertySearch/images/notfound.png';
const listingImgUrl = process.env.REACT_APP_PHOTO_LARGE_URL;
const listingImgFullSizeUrl = process.env.REACT_APP_PHOTO_XLARGE_URL;

const BREADCRUMB_TITLES = {
  ...PROPERTY_TYPE_MAP,
  residential: 'Residential For Sale',
  rental: 'Rentals'
};

class PropertyDetail extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      activeImage: undefined,
      showMap: false,
      showEmailModal: false
    };
  }

  render() {
    const {
      error,
      record,
      searchURI,
      detailURI,
      currentURI,
      id,
      isLoading,
      loaded,
      isFavorite = false,
      ADD_FAVORITE,
      REMOVE_FAVORITE
    } = this.props;
    const { propertyClass } = record;
    const { showEmailModal } = this.state;
    const searchTo = URI('/find-naples-home')
      .search({
        propertyClass:
          propertyClass && propertyClass !== 'residential' ? propertyClass : undefined
      })
      .toString();
    const isLoaded = !isLoading && loaded === id;
    const lat = parseFloat(record.get('latitude'), 10),
      lng = parseFloat(record.get('longitude'), 10);

    return (
      <Container
        className={cx(cmpStyle.detail, styles.PropertyDetail, styles[propertyClass])}
      >
        <Row>
          <Breadcrumb>
            <LinkContainer exact to="/">
              <BreadcrumbItem>
                <Link to="/">Home</Link>
              </BreadcrumbItem>
            </LinkContainer>
            <LinkContainer exact to="/find-naples-home">
              <BreadcrumbItem>
                <Link to="/find-naples-home">Property Search</Link>
              </BreadcrumbItem>
            </LinkContainer>
            {isLoaded && (
              <React.Fragment>
                <LinkContainer exact to={searchTo}>
                  <BreadcrumbItem>
                    <Link to={searchTo}>{BREADCRUMB_TITLES[propertyClass]}</Link>
                  </BreadcrumbItem>
                </LinkContainer>
                <BreadcrumbItem active>{this.getAddress()}</BreadcrumbItem>
              </React.Fragment>
            )}
          </Breadcrumb>
        </Row>
        <Container className={`${BS.breadcrumb2}`}>
          <Row>
            <Nav horizontal="space-between" className={`${BS.mb3}`}>
              {searchURI && !detailURI && (
                <NavItem>
                  <Button color="link" tag={Link} to={searchURI}>
                    &lt; Back
                  </Button>
                </NavItem>
              )}
              {detailURI && (
                <NavItem>
                  <Button color="link" tag={Link} to={detailURI}>
                    &lt; Back
                  </Button>
                </NavItem>
              )}
              <NavItem>
                <Nav horizontal="end">
                  <NavItem>
                    <Button
                      active={isFavorite}
                      color="link"
                      className={cx(styles.favoritesLink, {
                        [styles.active]: isFavorite
                      })}
                      onClick={() =>
                        isFavorite ? REMOVE_FAVORITE(record.id) : ADD_FAVORITE(record)
                      }
                    >
                      <span>
                        {isFavorite ? 'Remove from Favorites' : 'Add to Favorites'}
                      </span>
                      <MaterialIcon icon={'star_border'} />
                      <MaterialIcon icon={'star'} />
                    </Button>
                  </NavItem>
                  <NavItem>
                    <Button
                      color="link"
                      className={styles.favoritesLink}
                      title="Share Listing"
                      onClick={() => this.setState({ showEmailModal: true })}
                    >
                      <MaterialIcon icon={'share'} />
                    </Button>
                  </NavItem>
                </Nav>
              </NavItem>
            </Nav>
          </Row>
        </Container>
        {isLoading && <div className={BS.loadingMask}>Loading</div>}
        {error && <LoadError error={error} retry={() => this.reload()} />}
        {isLoaded && (
          <React.Fragment>
            {(record.get('status') === 'Pending' ||
              record.get('status') === 'Pending With Contingencies') && (
              <Alert className={styles.pendingBanner}>
                <MaterialIcon icon="pending" color="inherit" />
                Pending :: {moment(record.pendingDate).format('MM/DD/YYYY')}
              </Alert>
            )}
            {record.get('status') === 'Active' && (
              <Alert className={styles.activeBanner}>
                <MaterialIcon icon="check_circle" color="inherit" />
                Active Listing
              </Alert>
            )}
            {record.get('isSold') && (
              <Alert className={styles.soldBanner}>
                <MaterialIcon icon="check_circle" color="inherit" />
                Sold: {numeral(record.closingPrice || record.currentPrice).format(
                  '0,0'
                )}{' '}
                :: {moment(record.closingDate).format('MM/DD/YYYY')}
              </Alert>
            )}
            {this.renderCarousel()}
            <Row className={`${BS.gutters1}`}>
              <Col xs={12} md={4} className={`${cmpStyle.details} ${BS.mb3} ${BS.dFlex}`}>
                {this.renderDetails()}
              </Col>
              <Col xs={12} md={4} className={`${BS.mb3} ${BS.dFlex}`}>
                <div className={`${BS.p3} ${BS.border} ${BS.w100}`}>
                  <PropertyDetailContactAgentForm
                    record={record.get('displayAgent')}
                    onSubmit={(values, dispatch, props) =>
                      this.handleSubmit(values, dispatch, props)
                    }
                  />
                </div>
              </Col>
              <Col xs={12} md={4} className={`${BS.mb3} ${BS.dFlex}`}>
                <AgentCard
                  tag="div"
                  data={record.get('displayAgent').toJS()}
                  detailURI={currentURI}
                  propertyClass={propertyClass}
                />
              </Col>
            </Row>
            <div
              className={cx(cmpStyle.header, styles.header)}
              ref={header => (this.mapHeader = header)}
            >
              <h4>{this.getAddress()}</h4>
              {lat && lng ? (
                <Button
                  color="link"
                  onClick={() =>
                    this.setState({
                      showMap: !this.state.showMap
                    })
                  }
                >
                  View on Map <MaterialIcon icon="map" color="inherit" />
                </Button>
              ) : null}
            </div>
            {this.state.showMap && (
              <div className={styles.detailsMap}>
                <PropertyDetailMap record={record} />
              </div>
            )}
            <Row className={cmpStyle.details}>
              <Col xs={12} sm={4}>
                <h5>Description</h5>
              </Col>
              <Col xs={12} sm={8}>
                <p className={`${BS.mb0}`}>{record.get('propertyInfo')}</p>
              </Col>
            </Row>
            {this.renderGeneralInformation()}
            {this.renderAdditionalInformation()}
            {this.renderFinancialInformation()}
            {this.renderOpenHouseDates()}
            {/* [N2-609] - Remove any compensation references to listings on naplesarea.com */}
            {/* <Row className={cmpStyle.details}>
              <Col xs={12}>
                <p className={`${styles.notice}`}>
                  Compensation Disclaimer - The offer of compensation is made only to
                  participants of the MLS where the listing is filed.
                </p>
              </Col>
            </Row> */}
          </React.Fragment>
        )}
        {showEmailModal && (
          <FavoriteSearchEmailModal
            isOpen={showEmailModal}
            mlsIds={[record.get('mlsNumber')]}
            onToggle={isOpen =>
              this.setState({
                showEmailModal: isOpen !== undefined ? isOpen : !this.state.showEmailModal
              })
            }
          />
        )}
      </Container>
    );
  }

  renderList(items, renderInOrder) {
    if (renderInOrder) {
      return (
        <Row>
          <Col sm={6}>
            <ul>
              {items.slice(0, Math.ceil(items.length / 2)).map(function (item, i) {
                return <li key={i}>{item}</li>;
              })}
            </ul>
          </Col>
          <Col sm={6}>
            <ul>
              {items.slice(Math.ceil(items.length / 2)).map(function (item, i) {
                return <li key={i}>{item}</li>;
              })}
            </ul>
          </Col>
        </Row>
      );
    }
    return (
      <Row>
        <Col sm={6}>
          <ul>
            {items.map(function (item, i) {
              if (i !== 0 && i % 2 !== 0) {
                return null;
              }
              return <li key={i}>{item}</li>;
            })}
          </ul>
        </Col>
        <Col sm={6}>
          <ul>
            {items.map(function (item, i) {
              if (i === 0 || i % 2 === 0) {
                return null;
              }
              return <li key={i}>{item}</li>;
            })}
          </ul>
        </Col>
      </Row>
    );
  }

  renderCarousel() {
    const {
      record: { photos },
      record
    } = this.props;
    const { activeImage } = this.state;
    const lat = parseFloat(record.get('latitude'), 10),
      lng = parseFloat(record.get('longitude'), 10);

    var children = (
      lat && lng
        ? [
            <div className={cmpStyle.map} key={0}>
              <PropertyDetailMap
                record={record}
                onClick={() =>
                  this.setState({
                    showMap: true
                  })
                }
              />
            </div>
          ]
        : []
    ).concat(
      photos.map((photo, i) => {
        return (
          <img
            key={i + 1}
            className={cx(cmpStyle.image, BS.h100)}
            src={`${listingImgUrl}${photo.url}`}
            alt={photo.photoFilename}
            onClick={() => {
              this.showImageGalleryModal({ index: i });
            }}
            onError={e => {
              e.target.src = notfound;
            }}
          />
        );
      })
    );

    if (photos.size === 0) {
      children.push(
        <img
          key={children.length}
          src={notfound}
          alt="Not Found"
          className={cx(BS.imgFluid, BS.w100)}
        />
      );
    }

    return (
      <React.Fragment>
        <ResponsiveCarousel
          className={cmpStyle.gallery}
          itemClassName={cmpStyle.galleryItem}
          key="carousel"
          xsNumPerPage={1}
          mdNumPerPage={6}
          xsActiveIndex={lat && lng ? 1 : 0}
          placeholderImg={notfound}
          xsClassName={BS.col12}
          mdClassName={`${BS.col12} ${BS.colSm6} ${BS.colMd4}`}
          keyboard={activeImage === undefined}
          paused={!!activeImage}
          printNumPerPage={6}
          printClassName={`${BS.col12} ${BS.colSm6} ${BS.colMd4}`}
        >
          {children}
        </ResponsiveCarousel>
        {activeImage !== undefined && this.renderImageGalleryModal()}
      </React.Fragment>
    );
  }

  renderImageGalleryModal() {
    const { activeImage } = this.state;
    const {
      record: { photos }
    } = this.props;
    return (
      <Lightbox
        key="lightbox"
        isOpen
        currentImage={activeImage}
        backdropClosesModal
        images={photos.map(photo => {
          return {
            src: listingImgFullSizeUrl + photo.url,
            caption: photo.photoFilename
          };
        })}
        onClickNext={() => {
          this.showImageGalleryModal({ index: activeImage + 1 });
        }}
        onClickPrev={() => {
          this.showImageGalleryModal({ index: activeImage - 1 });
        }}
        onClose={() => {
          this.hideImageGalleryModal();
        }}
      />
    );
  }

  componentWillMount() {
    this.checkAndLoad();
  }

  componentDidUpdate(prevProps, prevState) {
    this.checkAndLoad();

    if (!prevState.showMap && this.state.showMap && this.mapHeader) {
      this.mapHeader.scrollIntoView();
    }
  }

  checkAndLoad() {
    const { loaded, isLoading, error, load, id, propertyClass } = this.props;
    if ((!loaded || loaded !== id) && !isLoading && (!error || loaded !== id)) {
      load({ id, propertyClass });
    }
  }

  reload() {
    const { load, id, propertyClass } = this.props;

    if (load && id) {
      load({ id, propertyClass });
    }
  }

  showImageGalleryModal({ index }) {
    this.setState({
      activeImage: index
    });
  }

  hideImageGalleryModal() {
    this.setState({
      activeImage: undefined
    });
  }

  renderGeneralInformation() {
    const { record } = this.props;
    const { propertyClass } = record;

    switch (propertyClass) {
      case 'land':
        return (
          <Row className={cx(cmpStyle.details, BS.gutters1)}>
            <Col xs={12} sm={4}>
              <div className={`${BS.p1}`}>
                <h5>General Property Information</h5>
              </div>
            </Col>
            <Col xs={12} sm={4}>
              <ListGroup className={`${cmpStyle.list} ${BS.p1}`}>
                <ListGroupItem>
                  <label>Lot Type:</label>
                  <strong>{record.get('lotType')}</strong>
                </ListGroupItem>

                <ListGroupItem>
                  <label>Usage:</label>
                  <strong>{record.get('usage')}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>County:</label>
                  <strong>{record.get('countyOrParish')}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Section:</label>
                  <strong>{record.get('section')}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Township:</label>
                  <strong>{record.get('township')}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Range:</label>
                  <strong>{record.get('range')}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Block:</label>
                  <strong>{record.get('block')}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Lot:</label>
                  <strong>{record.get('lotUnit')}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Legal Unit:</label>
                  <strong>{record.get('legalUnit')}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Elevation:</label>
                  <strong>{numeral(record.get('elevation')).format('0,0')}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Rear Exposure:</label>
                  <strong>{record.get('rearExposure')}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Prevoius Year Taxes:</label>
                  <strong>{numeral(record.get('taxes')).format('$0,0')}</strong>
                </ListGroupItem>
              </ListGroup>
            </Col>
            <Col xs={12} sm={4}>
              <ListGroup className={`${cmpStyle.list} ${BS.p1}`}>
                <ListGroupItem>
                  <label>Water Sewer:</label>
                  <strong>{record.get('sewer')}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Ground Cover:</label>
                  <strong>{record.get('groundCover')}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Improvements:</label>
                  <strong>
                    {record.get('landImprovements').trim().split(',').join(', ') ||
                      'None'}
                  </strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Waterfront:</label>
                  <strong>
                    {record.get('waterfront').trim().split(',').join(', ') || 'None'}
                  </strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>View:</label>
                  <strong>
                    {record.get('view').trim().split(',').join(', ') || 'None'}
                  </strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Boat Access:</label>
                  <strong>
                    {record.get('boatAccess').trim().split(',').join(', ') || 'None'}
                  </strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Utilities:</label>
                  <strong>
                    {record.get('utilitiesAvailable').trim().split(',').join(', ') ||
                      'None'}
                  </strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Zoning Code:</label>
                  <strong>{record.get('zoningCode') || 'None'}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Legal:</label>
                  <strong>{record.get('legalDesc')}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Potential Short Sale:</label>
                  <strong>{record.get('shortSale') ? 'Yes' : 'No'}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Foreclosure (REO):</label>
                  <strong>{record.get('foreclosed') ? 'Yes' : 'No'}</strong>
                </ListGroupItem>
              </ListGroup>
            </Col>
          </Row>
        );
      case 'commercial':
        return null;
      case 'residential':
      case 'rental':
      default:
        return (
          <Row className={cx(cmpStyle.details, BS.gutters1)}>
            <Col xs={12} sm={4}>
              <div className={`${BS.p1}`}>
                <h5>General Property Information</h5>
              </div>
            </Col>
            <Col xs={12} sm={4} className={`${BS.mb3}`}>
              <ListGroup className={`${cmpStyle.list} ${BS.p1}`}>
                <ListGroupItem>
                  <label>Property Class:</label>
                  <strong>{record.get('propertyType')}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Type:</label>
                  <strong>{record.get('bldgDesign')}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>MLS #:</label>
                  <strong>{record.get('mlsNumber')}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Furnished:</label>
                  <strong>{record.get('furnished')}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Unit Floor:</label>
                  <strong>{record.get('unitFloors')}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Total Floors:</label>
                  <strong>{record.get('totalFloors')}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Rear Exposure:</label>
                  <strong>{record.get('rearExposure')}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Private Pool:</label>
                  <strong>{record.get('privatePool') ? 'Yes' : 'No'}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Private Spa:</label>
                  <strong>{record.get('privateSpa') ? 'Yes' : 'No'}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Garage Spaces:</label>
                  <strong>{numeral(record.get('garages')).format('0')}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Garage:</label>
                  <strong>{record.get('garageDesc')}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Parking:</label>
                  <strong>{record.get('parking') || 'N/A'}</strong>
                </ListGroupItem>
              </ListGroup>
            </Col>
            <Col xs={12} sm={4} className={`${BS.mb3}`}>
              <ListGroup className={`${cmpStyle.list} ${BS.p1}`}>
                <ListGroupItem>
                  <label>Pets:</label>
                  <strong>{record.get('pets')}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Elevator:</label>
                  <strong>{record.get('elevator')}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Community Type:</label>
                  <strong>{record.get('communityType')}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Security:</label>
                  <strong>{record.get('security')}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>View:</label>
                  <strong>{record.get('view').trim().split(',').join(', ')}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Boat Access:</label>
                  <strong>{record.get('boatAccess').split(',').join(', ')}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Potential Short Sale:</label>
                  <strong>{record.get('shortSale') ? 'Yes' : 'No'}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Foreclosure (REO):</label>
                  <strong>{record.get('foreclosed') ? 'Yes' : 'No'}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Elementary School:</label>
                  <strong>{record.get('elementarySchool')}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>Middle Schoool:</label>
                  <strong>{record.get('middleSchool')}</strong>
                </ListGroupItem>
                <ListGroupItem>
                  <label>High School:</label>
                  <strong>{record.get('highSchool')}</strong>
                </ListGroupItem>
              </ListGroup>
            </Col>
          </Row>
        );
    }
  }

  renderAdditionalInformation() {
    const { record } = this.props;
    const { propertyClass } = record;

    switch (propertyClass) {
      case 'commercial':
      case 'land':
        return null;
      case 'residential':
      case 'rental':
      default:
        return (
          <Row className={cmpStyle.details}>
            <Col xs={12} sm={4}>
              <h5>Additional Information</h5>
            </Col>
            <Col xs={12} sm={8}>
              <Row className={BS.gutters1}>
                <Col xs={12} sm={6}>
                  <div className={BS.p1}>
                    <strong>Amenities</strong>
                    {this.renderList(compact((record.get('amenities') || '').split(',')))}
                  </div>
                </Col>
                <Col xs={12} sm={6}>
                  <div className={BS.p1}>
                    <strong>Equipment</strong>
                    {this.renderList(compact((record.get('equipment') || '').split(',')))}
                  </div>
                </Col>
              </Row>
              <Row className={BS.gutters1}>
                <Col xs={12} sm={6}>
                  <div className={BS.p1}>
                    <strong>Interior</strong>
                    {this.renderList(compact((record.get('interior') || '').split(',')))}
                  </div>
                </Col>
                <Col xs={12} sm={6}>
                  <div className={BS.p1}>
                    <strong>Exterior</strong>
                    {this.renderList(compact((record.get('exterior') || '').split(',')))}
                  </div>
                </Col>
              </Row>
              {record.get('monthsAvailable') && (
                <Row className={BS.gutters1}>
                  <Col xs={12}>
                    <div className={BS.p1}>
                      <strong>Months Available</strong>
                      {this.renderList(
                        compact((record.get('monthsAvailable') || '').split(',')),
                        true
                      )}
                    </div>
                  </Col>
                </Row>
              )}
              {record.get('weeksAvailable') && (
                <Row className={BS.gutters1}>
                  <Col xs={12}>
                    <div className={BS.p1}>
                      <strong>Weeks Available</strong>
                      {this.renderList(
                        compact(
                          (record.get('weeksAvailable') || '').split(
                            /(\d{4},[\s\w]+),/gim
                          )
                        ),
                        true
                      )}
                    </div>
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        );
    }
  }

  renderFinancialInformation() {
    const { record } = this.props;
    const { propertyClass } = record;

    if (propertyClass !== 'residential') {
      return null;
    }

    return (
      <Row className={cx(cmpStyle.details)}>
        <Col xs={12} sm={4}>
          <div className={`${BS.p1}`}>
            <h5>Financial Information</h5>
          </div>
        </Col>
        <Col xs={12} sm={8} className={`${BS.mb3}`}>
          <Row className={cx(BS.gutters1)}>
            <Col xs={12} sm={6}>
              <div className={BS.p1}>
                <strong>Taxes</strong>
                <ListGroup className={`${cmpStyle.list} ${BS.p1}`}>
                  <ListGroupItem>
                    <label>Tax Type:</label>
                    <strong>{record.get('taxDesc')}</strong>
                  </ListGroupItem>
                  <ListGroupItem>
                    <label>Tax District:</label>
                    <strong>{record.get('taxDistrictType')}</strong>
                  </ListGroupItem>
                  <ListGroupItem>
                    <label>Taxes:</label>
                    <strong>{numeral(record.get('taxes')).format('$0,0')}</strong>
                  </ListGroupItem>
                  <ListGroupItem>
                    <label>Tax Year:</label>
                    <strong>{record.get('taxYear')}</strong>
                  </ListGroupItem>
                  <ListGroupItem>&nbsp;</ListGroupItem>
                </ListGroup>
                {/* [N2-609] - Remove any compensation references to listings on naplesarea.com */}
                {/* <strong>Compensation Information</strong>
                <ListGroup className={`${cmpStyle.list} ${BS.p1}`}>
                  <ListGroupItem>
                    <label>Single Agent Compensation:</label>
                    <strong>{record.get('buyerAgentComp') || 'N/A'}</strong>
                  </ListGroupItem>
                  <ListGroupItem>
                    <label>Transaction Broker Compensation:</label>
                    <strong>{record.get('transBrokerComp') || 'N/A'}</strong>
                  </ListGroupItem>
                  <ListGroupItem>
                    <label>NonRep Compensation:</label>
                    <strong>{record.get('nonRepComp') || 'N/A'}</strong>
                  </ListGroupItem>
                </ListGroup> */}
              </div>
            </Col>
            <Col xs={12} sm={6}>
              <div className={BS.p1}>
                <strong>Fees</strong>
                <ListGroup className={`${cmpStyle.list} ${BS.p1}`}>
                  <ListGroupItem>
                    <label>HOA:</label>
                    <strong>{record.get('hoaDesc') || 'N/A'}</strong>
                  </ListGroupItem>
                  <ListGroupItem>
                    <label>HOA Fee:</label>
                    <strong>
                      {record.get('hoaFreq')
                        ? compact([
                            numeral(record.get('hoaFee')).format('$0,0'),
                            record.get('hoaFreq')
                          ]).join(' / ')
                        : 'N/A'}
                    </strong>
                  </ListGroupItem>
                  <ListGroupItem>
                    <label>Master HOA Fee:</label>
                    <strong>
                      {record.get('masterHOAFreq')
                        ? compact([
                            numeral(record.get('masterHOAFee')).format('$0,0'),
                            record.get('masterHOAFreq')
                          ]).join(' / ')
                        : 'N/A'}
                    </strong>
                  </ListGroupItem>
                  <ListGroupItem>
                    <label>Condo Fee:</label>
                    <strong>
                      {record.get('condoFeeFreq')
                        ? compact([
                            numeral(record.get('condoFee')).format('$0,0'),
                            record.get('condoFeeFreq')
                          ]).join(' / ')
                        : 'N/A'}
                    </strong>
                  </ListGroupItem>
                  <ListGroupItem>
                    <label>Mandatory Club Fees:</label>
                    <strong>
                      {record.get('clubFeeFreq')
                        ? compact([
                            numeral(record.get('clubFee')).format('$0,0'),
                            record.get('clubFeeFreq')
                          ]).join(' / ')
                        : 'N/A'}
                    </strong>
                  </ListGroupItem>
                </ListGroup>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }

  renderDetails() {
    const { record } = this.props;
    const { propertyClass } = record;

    switch (propertyClass) {
      case 'rental':
        return (
          <ListGroup className={`${cmpStyle.list} ${BS.w100} ${BS.p1}`}>
            {record.get('monthlyRate') && (
              <ListGroupItem>
                <label>Monthly Rate:</label>
                <strong>{numeral(record.get('monthlyRate')).format('$0,0')}</strong>
              </ListGroupItem>
            )}
            {record.get('seasonRate') && (
              <ListGroupItem>
                <label>Seasonal Rate:</label>
                <strong>{numeral(record.get('seasonRate')).format('$0,0')}</strong>
              </ListGroupItem>
            )}
            {record.get('offSeasonRate') && (
              <ListGroupItem>
                <label>Off-Season Rate:</label>
                <strong>{numeral(record.get('offSeasonRate')).format('$0,0')}</strong>
              </ListGroupItem>
            )}
            {record.get('weeklyRate') && (
              <ListGroupItem>
                <label>Weekly Rate:</label>
                <strong>{numeral(record.get('weeklyRate')).format('$0,0')}</strong>
              </ListGroupItem>
            )}
            {record.get('rnTerm') && (
              <ListGroupItem>
                <label>Rental Term:</label>
                <strong>{record.get('rnTerm')}</strong>
              </ListGroupItem>
            )}
            <ListGroupItem>
              <label>Type:</label>
              <strong>{record.get('bldgDesign')}</strong>
            </ListGroupItem>
            <ListGroupItem>
              <label>Year Built:</label>
              <strong>{record.get('yearBuilt')}</strong>
            </ListGroupItem>
            <ListGroupItem>
              <label>SQ FT:</label>
              <strong>{numeral(record.get('livingArea')).format('0,0')}</strong>
            </ListGroupItem>
            <ListGroupItem>
              <label>Beds:</label>
              <strong>{record.get('bedrooms')}</strong>
            </ListGroupItem>
            <ListGroupItem>
              <label>Baths:</label>
              <strong>
                {record.get('bathsFull')} / {record.get('bathsHalf')}
              </strong>
            </ListGroupItem>
            <ListGroupItem>
              <label>MLS #:</label>
              <strong>{record.get('mlsNumber')}</strong>
            </ListGroupItem>
          </ListGroup>
        );
      case 'commercial':
        return (
          <ListGroup className={`${cmpStyle.list} ${BS.w100} ${BS.p1}`}>
            <ListGroupItem>
              <label>Price:</label>
              <strong>{numeral(record.get('currentPrice')).format('$0,0')}</strong>
            </ListGroupItem>
            <ListGroupItem>
              <label>Trans. Type:</label>
              <strong>{record.get('transactionType')}</strong>
            </ListGroupItem>
            <ListGroupItem>
              <label>Property Class:</label>
              <strong>{record.get('commercialType')}</strong>
            </ListGroupItem>
            <ListGroupItem>
              <label>Property Type:</label>
              <strong>{record.get('propertyType')}</strong>
            </ListGroupItem>
            <ListGroupItem>
              <label>SQFT:</label>
              <strong>{numeral(record.get('subjectPropertySqFt')).format('0,0')}</strong>
            </ListGroupItem>
            <ListGroupItem>
              <label>Year Built:</label>
              <strong>{record.get('yearBuilt')}</strong>
            </ListGroupItem>
            <ListGroupItem>
              <label>MLS #:</label>
              <strong>{record.get('mlsNumber')}</strong>
            </ListGroupItem>
            <ListGroupItem>
              <label>Community:</label>
              <strong>{record.get('development')}</strong>
            </ListGroupItem>
          </ListGroup>
        );
      case 'land':
        return (
          <ListGroup className={`${cmpStyle.list} ${BS.w100} ${BS.p1}`}>
            <ListGroupItem>
              <label>Price:</label>
              <strong>{numeral(record.get('currentPrice')).format('$0,0')}</strong>
            </ListGroupItem>
            <ListGroupItem>
              <label>Property Class:</label>
              <strong>{record.get('propertyType')}</strong>
            </ListGroupItem>
            <ListGroupItem>
              <label>Price/Acre:</label>
              <strong>{numeral(record.get('pricePerAcre')).format('$0,0')}</strong>
            </ListGroupItem>
            <ListGroupItem>
              <label>Acreage:</label>
              <strong>{numeral(record.get('acres')).format('0,0.00')}</strong>
            </ListGroupItem>
            <ListGroupItem>
              <label>Dimensions:</label>
              <strong>
                {numeral(record.get('lotFrontage')).format('0,0')}
                {' X '}
                {numeral(record.get('lotLeft')).format('0,0')}
                {' X '}
                {numeral(record.get('lotBack')).format('0,0')}
                {' X '}
                {numeral(record.get('lotRight')).format('0,0')}
              </strong>
            </ListGroupItem>
            <ListGroupItem>
              <label>Lot Desc:</label>
              <strong>{record.get('lot')}</strong>
            </ListGroupItem>
            <ListGroupItem>
              <label>MLS #:</label>
              <strong>{record.get('mlsNumber')}</strong>
            </ListGroupItem>
            <ListGroupItem>
              <label>Sub / Condo:</label>
              <strong>{record.get('condoName')}</strong>
            </ListGroupItem>
            <ListGroupItem>
              <label>Community:</label>
              <strong>{record.get('developmentName')}</strong>
            </ListGroupItem>
          </ListGroup>
        );
      case 'residential':
      default:
        return (
          <ListGroup className={`${cmpStyle.list} ${BS.w100} ${BS.p1}`}>
            <ListGroupItem>
              <label>Price:</label>
              <strong>{numeral(record.get('currentPrice')).format('$0,0')}</strong>
            </ListGroupItem>
            <ListGroupItem>
              <label>Type:</label>
              <strong>{record.get('bldgDesign')}</strong>
            </ListGroupItem>
            <ListGroupItem>
              <label>Year Built:</label>
              <strong>{record.get('yearBuilt')}</strong>
            </ListGroupItem>
            <ListGroupItem>
              <label>SQ FT:</label>
              <strong>{numeral(record.get('livingArea')).format('0,0')}</strong>
            </ListGroupItem>
            <ListGroupItem>
              <label>Beds:</label>
              <strong>{record.get('bedrooms')}</strong>
            </ListGroupItem>
            <ListGroupItem>
              <label>Baths:</label>
              <strong>
                {record.get('bathsFull')} / {record.get('bathsHalf')}
              </strong>
            </ListGroupItem>
            <ListGroupItem>
              <label>MLS #:</label>
              <strong>{record.get('mlsNumber')}</strong>
            </ListGroupItem>
            <ListGroupItem>
              <label>Sub / Condo:</label>
              <strong>{record.get('condoName')}</strong>
            </ListGroupItem>
            <ListGroupItem>
              <label>Community:</label>
              <strong>{record.get('developmentName')}</strong>
            </ListGroupItem>
            <ListGroupItem>
              <label>Next Open House:</label>
              <strong>{this.getNextOpenHouse()}</strong>
            </ListGroupItem>
          </ListGroup>
        );
    }
  }

  renderOpenHouseDates() {
    const { record } = this.props;
    const { propertyClass } = record;
    const openhouses = record.get('openhouses').map(({ startDate, endDate }) => {
      const openhouseDate = compact([
        moment(startDate).format('MM/DD/YY ha'),
        endDate && moment(endDate).format('ha')
      ]).join(' - ');

      return openhouseDate;
    });

    if (propertyClass !== 'residential') {
      return null;
    }

    return (
      <Row className={cx(cmpStyle.details)}>
        <Col xs={12} sm={openhouses.length === 0 ? 12 : 4}>
          <div className={`${BS.p1}`}>
            <h5>Open House Dates</h5>
            {openhouses.length === 0 && (
              <p>There are no upcoming open house dates for this property.</p>
            )}
          </div>
        </Col>
        {openhouses.length > 0 && (
          <Col xs={12} sm={8} className={`${BS.mb3}`}>
            {this.renderList(openhouses)}
          </Col>
        )}
      </Row>
    );
  }

  getNextOpenHouse() {
    const { record } = this.props;
    const openhouses = record.get('openhouses');

    const openhouse = openhouses.find(function (openhouse) {
      return moment(openhouse.startDate).isSameOrAfter(moment().startOf('DAY'));
    });

    if (!openhouse) {
      return 'N/A';
    }

    const openhouseDate = compact([
      moment(openhouse.startDate).format('MM/DD/YY ha'),
      openhouse.endDate && moment(openhouse.endDate).format('ha')
    ]).join(' - ');

    return openhouseDate;
  }

  handleSubmit(values, dispatch, props) {
    const { id } = this.props;

    return CONTACT_SUBMIT({
      ...values,
      type: 'property',
      id
    });
  }

  getAddress() {
    const { record } = this.props;
    return compact([
      (record.get('fullAddress') || '').trim(),
      (record.get('city') || '').trim(),
      (record.get('stateOrProvince') || '').trim(),
      (record.get('postalCode') || '').trim()
    ]).join(', ');
  }
}

export default connect(
  (state, props) => {
    const params = props.match.params.id.split('-');
    const id = params[0];
    const propertyClass = params[1];
    const { searchURI, detailURI } = URI(state.routing.location.search).search(true);
    const { pathname, search = {} } = state.routing.location;
    const record = state.PropertySearch.getIn(['detail', 'record']);
    return {
      id: isNaN(id) ? id : parseInt(id, 10),
      record,
      propertyClass: propertyClass || record.get('propertyClass'),
      isLoading: state.PropertySearch.getIn(['detail', 'loading']),
      loaded: state.PropertySearch.getIn(['detail', 'loaded']),
      error: state.PropertySearch.getIn(['detail', 'error']),
      // These additional URIjs methods are being called to santitize the URL
      searchURI: searchURI
        ? URI(searchURI).protocol('').hostname('').port('').normalizePathname().toString()
        : '/find-naples-home',
      detailURI:
        detailURI &&
        URI(detailURI).protocol('').hostname('').port('').normalizePathname().toString(),
      currentURI: pathname && URI(pathname).search(search).toString(),

      isFavorite: isFavorite(state, record.id)
    };
  },
  {
    load: fetch,
    ADD_FAVORITE,
    REMOVE_FAVORITE
  }
)(PropertyDetail);



// WEBPACK FOOTER //
// ./src/containers/PropertyDetail/PropertyDetail.js